import { NAT_NUM_30_39 } from "../../../../SubjectData/BasicWords/Numbers/NatNums.js";
import "../../../Deck.css";
import FlashcardInterface from "../../../Flashcard_Interface.js";
import HeaderNav from "../../../../Components/Header/Header_Nav/Header_Nav.js";

export default function NAT_NUM_30_39_DECK() {
  return (
    <>
      <HeaderNav GoBack_to="/NumbersNav" />
      <FlashcardInterface deckData={NAT_NUM_30_39} title="Native Numbers: 30-39" />
    </>
  );
}
